var _style, _symbol, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCreditcard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 36 36",
    style: {
      enableBackground: "new 0 0 36 36"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.creditcard-st0{fill:#808080;}\r\n\t.creditcard-st1{opacity:0;fill:#808080;}\r\n")), _symbol || (_symbol = /*#__PURE__*/React.createElement("symbol", {
    id: "New_Symbol_3",
    viewBox: "-75.6 -52.1 151 105"
  }, /*#__PURE__*/React.createElement("path", {
    className: "creditcard-st0",
    d: "M61.9-52.1h-124c-7.4,0-13.5,6.1-13.5,13.5v78c0,7.4,6.1,13.5,13.5,13.5h124c7.4,0,13.5-6.1,13.5-13.5v-78 C75.4-46,69.3-52.1,61.9-52.1z M-62.1,49.9c-5.8,0-10.5-4.7-10.5-10.5v-78c0-5.8,4.7-10.5,10.5-10.5h124c5.8,0,10.5,4.7,10.5,10.5 v78c0,5.8-4.7,10.5-10.5,10.5H-62.1z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -73.6,
    y: 13.9,
    className: "creditcard-st0",
    width: 147,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: -73.7,
    y: 34.7,
    className: "creditcard-st0",
    width: 147,
    height: 3
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    y: 0,
    className: "creditcard-st1",
    width: 36,
    height: 36
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#New_Symbol_3",
    width: 151,
    height: 105,
    x: -75.6,
    y: -52.1,
    transform: "matrix(0.1929 0 0 -0.1929 18 18)",
    style: {
      overflow: "visible"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditcard);
export default __webpack_public_path__ + "static/media/creditcard.fb90baaa.svg";
export { ForwardRef as ReactComponent };